<app-switch-stage-form [stage]="stage"
    (stageUpdateNotification$)="updateStageNotification($event)"></app-switch-stage-form>